import { useEffect } from 'react'
import { connect } from "react-redux";
import { beforeApp, getRate, getAnnRate } from './App.action';
import { beforeWallet } from './components/wallet/wallet.action';
import { useHistory } from 'react-router-dom';

const Getter = (props) => {
    const history = useHistory();

    useEffect(() => {
        if (props.wallet.redirectW) {
            props.beforeWallet()
            history.push('/login')
        }
    }, [props.wallet.redirectW])

    useEffect(() => {
        props.getRate('2710')
        props.getAnnRate()
    }, [])

    useEffect(() => {
        // when an error is received
        if (props.error) {
            // if user is not found, clear storage and redirect to connect wallet screen
            if (props.error.user404) {
                localStorage.clear()
                history.push('/login')
            }
        }
    }, [props.error])

    return (
        <>
        </>
    )
}

const mapStateToProps = (state) => ({
    app: state.app,
    wallet: state.wallet,
    error: state.error
});

export default connect(mapStateToProps, { beforeApp, getRate, getAnnRate, beforeWallet })(Getter);
